import Vue from 'vue'
import Router from 'vue-router'
import CheckIn from '@/components/CheckIn'
import StoreSelector from '@/components/StoreSelector'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: StoreSelector
    },
    {
      path: '/b/:checkin_key',
      component: CheckIn,
      props: true,
      name: 'editBuy'
    },
    {
      path: '/b/',
      component: CheckIn,
      props: true,
      redirect: '/'
    },
    {
      path: '/s/:store_number/b',
      component: CheckIn,
      props: true,
      name: 'newStoreBuy'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js